import React from "react";

import trustedJwellers from "../AlIimage/trustedJwellers.png";
import certifiedDiamonds from "../AlIimage/certifiedDiamonds.png";
import freeShipping from "../AlIimage/FreeShipping.png";
import easyReturns from "../AlIimage/EasyReturns.png";
import yearsoftrust from "../AlIimage/125Years.png";
import BisCertified from "../AlIimage/BisCertified.png";
import { useMediaQuery } from "react-responsive";
import InstagramFeed from "./InstagramFeed";

const FollowUsPage = () => {
  const isSmallScreen = useMediaQuery({ maxWidth: 600 });
  return (
    <>
      <div
        style={{
          backgroundColor: "#E1F3FF",
          padding: "1rem 0rem ",
        }}
      >
        <div
          className="container2"
          style={{ marginTop: isSmallScreen ? "-1rem" : "1rem" }}
        >
          <div className="row" style={{ margin: "auto" }}>
            <div className="col-sm-12 col-md-4 col-lg-4 ">
              <span className="followUs">
                FOLLOW US ON INSTAGRAM
              </span>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "0.5rem",
                }}
              >
                <a
                  href="https://www.instagram.com/jatinmorjewels/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#285979",
                    fontFamily: "Raleway",
                    fontSize: isSmallScreen ? "0.9rem" : "1rem",
                    textDecoration: "underline",
                  }}
                >
                  @jatinmorjewels
                </a>
              </div>
            </div>

            <div className="col-sm-12 col-md-8 col-lg-8 mt-1">
              <InstagramFeed />
            </div>
          </div>
        </div>
        <div
          className="trust-icons-row"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "1.5rem",
            margin: "2rem 1rem",
          }}
        >
          <div style={{ width: "80px", flexShrink: 0 }}>
            <img width={"100%"} src={trustedJwellers} alt="Trusted Jewellers" />
          </div>
          <div style={{ width: "80px", flexShrink: 0 }}>
            <img width={"100%"} src={certifiedDiamonds} alt="Certified Diamonds" />
          </div>
          <div style={{ width: "80px", flexShrink: 0 }}>
            <img width={"100%"} src={BisCertified} alt="BIS Certified" />
          </div>
          <div style={{ width: "80px", flexShrink: 0 }}>
            <img width={"100%"} src={yearsoftrust} alt="125 Years of Trust" />
          </div>
          <div style={{ width: "80px", flexShrink: 0 }}>
            <img width={"100%"} src={freeShipping} alt="Free Shipping" />
          </div>
          <div style={{ width: "80px", flexShrink: 0 }}>
            <img width={"100%"} src={easyReturns} alt="Easy Returns" />
          </div>
        </div>
      </div>
    </>
  );
};

export default FollowUsPage;
